import { pipe } from 'ramda';
import { selectPlayerShip } from '../../ship/ship.selectors';
import { isDead } from '../../../../app/core/ship/ship.utils';
import { selectOpponentShip } from '../encounter.selectors';

export const selectIsOpponentDead = pipe(selectOpponentShip, isDead);
export const selectIsPlayerDead = pipe(selectPlayerShip, isDead);
